import { PlatformMessageStalledMessagesListItemDTO } from "@bvhi/backend-api";
import { GridColDef } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DateCell } from "../../../../../components/datagrid/cells/date-cell";
import { MessageTypeCell } from "../components/message-type-cell";
import { useMessagesSortParams } from "./use-messages-sort-params";

export const useStalledMessagesDataGridDefinitions = () => {
  const { t } = useTranslation(["messages"]);
  const { isFieldSortable } = useMessagesSortParams();

  const columns: GridColDef<PlatformMessageStalledMessagesListItemDTO>[] = useMemo(() => {
    return [
      {
        field: "messageType",
        headerName: t("messages:datagrid.messageType"),
        minWidth: 150,
        width: 250,
        maxWidth: 300,
        sortable: isFieldSortable("messageType"),
        renderCell: (params) => <MessageTypeCell type={params.row.messageType} />,
      },
      {
        field: "audiologistOrganisationName",
        headerName: t("messages:datagrid.audiologistOrganisationName"),
        minWidth: 150,
        width: 250,
        maxWidth: 500,
        sortable: isFieldSortable("audiologistOrganisationName"),
      },
      {
        field: "senderOrganisationName",
        headerName: t("messages:datagrid.senderOrganisationName"),
        minWidth: 150,
        width: 250,
        maxWidth: 500,
        sortable: isFieldSortable("senderOrganisationName"),
      },
      {
        field: "receiverOrganisationName",
        headerName: t("messages:datagrid.receiverOrganisationName"),
        minWidth: 150,
        width: 250,
        maxWidth: 500,
        sortable: isFieldSortable("receiverOrganisationName"),
      },
      {
        field: "expiresAt",
        headerName: t("messages:datagrid.expiresAt"),
        minWidth: 150,
        width: 250,
        maxWidth: 300,
        sortable: isFieldSortable("expiresAt"),
        renderCell: (params) => <DateCell date={params.row.expiresAt} />,
      },
    ];
  }, [t, isFieldSortable]);

  return { columns };
};
